// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_f3-0";
export var headerCellHover = "_f3-1";